import { getRecoil } from "recoil-nexus";
import participantsState from "../../atoms/participants";
import { socket } from "../index";

interface ListenReceiveDestroyRoomPayload {
  roomId: string;
}

const listenReceiveDestroyRoom = () => {
  socket?.on('RECEIVE_DESTROY_ROOM', (payload: ListenReceiveDestroyRoomPayload) => {
    const participants = getRecoil(participantsState);
    if (payload.roomId !== participants.roomId) {
      return;
    }

    window.alert('접속한 방이 방장에 의해 삭제되어, 대기실로 이동합니다.');
    window.location.href = '/chatting-app/waiting-room';
  });
}

export default listenReceiveDestroyRoom;